<template>
  <div>
    <p class="font-bold mt-3 text-lg" style="margin-left: 20px">School Registrations</p>
    <div style="padding: 20px;">
      <el-table :data="dataList" style="font-size: 12px;box-sizing: border-box;" empty-text="No Data"
        :highlight-current-row="false" :highlight-selection-row="false" :header-cell-class-name="'custom-head-cell'"
        :cell-style="tableCellstyle" :row-class-name="'custom-row-bg'">
        <el-table-column prop="project.project_ename" label="Program" min-width="220">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; justify-content: center;">
              <span 
                @click="goToProjectDetail(scope.row.project)" 
                style="cursor: pointer; color: #409EFF;">
                {{ scope.row.project.project_ename }}
              </span>
              <i 
                class="el-icon-info" 
                style="margin-left: 5px; color: #409EFF; cursor: pointer; flex-shrink: 0;" 
                @click="goToProjectDetail(scope.row.project)" 
                title="View Project Details">
              </i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Status" width="110px">
          <template slot-scope="scope">
            <el-tag
              :type="getSchoolProgramStatusType(scope.row.application_status)"
              size="small">
              {{ getSchoolProgramStatusLabel(scope.row.application_status, scope.row.project) }}
            </el-tag>
            <div v-if="scope.row.application_status === '无需缴费'" style="color: #666; font-size: 11px; margin-top: 4px; line-height: 14px;">
              Fee covered by institution
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Notes" width="240">
          <template slot-scope="scope">
            <span v-if="getRowBu(scope.row) === 'AM'" class="notes-am-text">
              {{ getAmParticipationNote(scope.row) }}
            </span>
            <div
              v-else-if="getRowBu(scope.row) === 'NIM'"
              class="notes-nim-cycles">
              <div
                v-for="cycle in getNimReviewCycles(scope.row)"
                :key="cycle.name || cycle.announce_date"
                class="notes-nim-cycle">
                <div class="notes-nim-cycle-name">{{ getReviewCycleDisplayName(cycle) }}</div>
                <div v-if="cycle.announce_date" class="notes-nim-cycle-date">
                  Results: {{ formatReviewDate(cycle.announce_date) }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Coordinator" width="150px">
          <template slot-scope="scope">
            <div v-for="(contact, index) in scope.row.contacts" :key="index">
              <p>{{ formatContactName(contact) }} </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="project.project_ename" label="Operation">
          <template slot-scope="scope">
            <el-button v-if="!isInstitutionPaymentPending(scope.row)" type="primary" size="small" @click="showDialog(scope.row)">Assign Coordinator</el-button>
            <el-button v-if="scope.row.application_status === '已缴费' || isStandardRegistration(scope.row)" type="primary" size="small" @click="showRegistrationLink(scope.row)">
              Registration Link</el-button>
            <el-dropdown
              v-if="hasRegistrationResourceActions(scope.row)"
              trigger="click"
              @command="command => handleRegistrationResourceAction(command, scope.row)">
              <el-button plain type="primary" size="small">
                Resources <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="invoice">Download Invoice</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.application_status === '已缴费'" command="receipt">Download Receipt</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.application_status === '已缴费' && scope.row.participation_arrangement === 'School day'" command="brandAuth">Brand Authorization</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button 
              v-if="isInstitutionPaymentPending(scope.row)"
              type="warning" 
              size="small"
              @click="viewPaymentDetails(scope.row)">
              Payment Details
            </el-button>
            <!-- <el-button type="danger" disabled>Manage</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="isShowDialog" title="Assign Advisor" width="600px" @close="closeDialog">
      <div>
        <el-form :inline="true" ref="form">
          <el-form-item label="Select program advisor(s)">
            <el-select v-model="selectContactIds" placeholder="Please select" :multiple="true" style="width: 400px;">
              <el-option v-for="(contact, index) in teacherOpt" :key="index" :label="formatContactName(contact)"
                :value="contact._id.$id">
              </el-option>
            </el-select>
          </el-form-item>
          <p>*Emails to students for the project will also go to the assigned program advisor.</p>
        </el-form>
        <div style="width: 100%; text-align: center; margin-top: 30px">
          <el-button size="medium" @click="isShowDialog = false">Cancel</el-button>
          <el-button type="primary" size="medium" @click="saveInfo()">Confirm</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showPaymentDetailsDialog" title="Payment Details" width="70%">
      <div v-loading="loadingPaymentDetails">
        <div v-if="currentPayment" style="padding: 0 20px; word-break: keep-all; white-space: normal;">
          <h3 style="text-align: center; color: #606266; margin-bottom: 20px;">
            {{ currentPayment.project?.project_ename || 'Program' }} Payment Details
          </h3>
          
          <el-descriptions border>
            <el-descriptions-item label="Payment ID" :span="2">
              {{ currentPayment._id?.$id || 'N/A' }}
            </el-descriptions-item>
            <el-descriptions-item label="Status">
              <el-tag :type="getPaymentStatusType(currentPayment.application_status)">
                {{ getSchoolProgramStatusLabel(currentPayment.application_status, currentPayment.project) }}
              </el-tag>
            </el-descriptions-item>

            <el-descriptions-item label="Standard fee" :span="2">
              {{ formatCurrency(currentPayment.standard_fee || currentPayment.institution_price || currentPayment.project.project_price) }}
            </el-descriptions-item>

            <el-descriptions-item label="Applicable fee reduction" :span="2">
              {{ formatCurrency(calcReductionAmount(currentPayment)) }}
            </el-descriptions-item>
            
            <el-descriptions-item label="Fee after reduction" :span="2">
              {{ formatCurrency(currentPayment.total_price || currentPayment.institution_price || 0) }}
            </el-descriptions-item>
            <el-descriptions-item label="Payment Service Fee" :span="2">
              {{ formatCurrency(currentPayment.service_fee || 0) }}
            </el-descriptions-item>
            <el-descriptions-item label="GST" :span="2">
              0.00 (not included under current exemption policy)
            </el-descriptions-item>
            <el-descriptions-item label="Date">
              {{ formatDate(currentPayment.created_at) }}
            </el-descriptions-item>
            
            <el-descriptions-item label="Payment Method" :span="3">
              {{ currentPayment.payment_method || 'N/A' }}
            </el-descriptions-item>

            <el-descriptions-item label="Proof of Payment" :span="3">
              <div v-if="currentPayment.institution_payment_proof_url">
                <a :href="currentPayment.institution_payment_proof_url" target="_blank" rel="noopener noreferrer">View uploaded proof</a>
                <el-tag size="mini" style="margin-left: 8px;" :type="getProofStatusType(currentPayment.institution_payment_proof_status)">
                  {{ currentPayment.institution_payment_proof_status || 'Awaiting finance verification' }}
                </el-tag>
                <div style="font-size: 12px;color: #909399;margin-top: 4px;">
                  {{ currentPayment.institution_payment_proof_file_name || '' }}
                  <span v-if="currentPayment.institution_payment_proof_uploaded_time">
                    Uploaded {{ formatUnixTime(currentPayment.institution_payment_proof_uploaded_time) }}
                  </span>
                </div>
              </div>
              <span v-else>Not uploaded</span>
            </el-descriptions-item>
            
            <el-descriptions-item label="Invoice Number" :span="3" v-if="currentPayment.invoice_number">
              {{ currentPayment.invoice_number }}
            </el-descriptions-item>
            
            <el-descriptions-item label="Notes" :span="3" v-if="currentPayment.notes">
              {{ currentPayment.notes }}
            </el-descriptions-item>
          </el-descriptions>
          <div class="order-total-line">
            <span>Total order amount</span>
            <strong>{{ formatCurrency(getTotalOrderAmount(currentPayment)) }}</strong>
          </div>
          
          <div v-if="currentPayment.receipt_url" style="margin-top: 20px; text-align: center;">
            <el-button type="primary" icon="el-icon-document" @click="downloadReceipt(currentPayment.receipt_url)">
              Download Receipt
            </el-button>
          </div>
          
          <div v-if="currentPayment.application_status === '待缴费' || currentPayment.application_status === '部分支付'" style="margin-top: 30px;">
            <h4 style="color: #606266; margin-bottom: 15px;">Payment Options</h4>
            <el-divider></el-divider>
            <div class="institution-terms-block">
              <div class="terms-title">Institution Terms & Conditions / Refund Policy</div>
              <div class="terms-content ql-snow ql-editor" v-html="getInstitutionTermsPolicy(currentPayment)"></div>
              <el-checkbox v-model="paymentTermsAccepted" style="margin-top: 12px;">
                I have read and accept the payment terms and conditions above.
              </el-checkbox>
            </div>
            
            <el-row :gutter="20" style="margin-top: 20px">
              <el-col :span="12">
                <el-card shadow="hover" @click.native="selectPaymentMethod('creditCard')" 
                        :class="{'payment-method-selected': selectedPaymentMethod === 'creditCard'}">
                  <div style="text-align: center; cursor: pointer;">
                    <i class="el-icon-bank-card" style="font-size: 36px; color: #409EFF;"></i>
                    <h4>Credit/Debit Card</h4>
                    <p style="font-size: 12px; color: #909399;margin-top: 10px;">Pay securely with a credit/debit card via Stripe and then use the invoice & receipt to get reimbursed from your school.<br>Your transaction will be instantly processed.</p>
                  </div>
                  <div style="margin-top: 20px; text-align: center;" class="payment-buttons">
                    <el-button 
                      type="primary" 
                      class="action-button"
                      :disabled="!paymentTermsAccepted"
                      @click="proceedToPayment">
                      Proceed to Payment Page
                    </el-button>
                    <el-button 
                      type="primary" 
                      class="action-button"
                      
                      @click="downloadInvoice">
                      Download Invoice
                    </el-button>
                  </div>
                </el-card>
                
              </el-col>
              
              <el-col :span="12">
                <el-card shadow="hover" @click.native="selectPaymentMethod('bankTransfer')"
                        :class="{'payment-method-selected': selectedPaymentMethod === 'bankTransfer'}">
                  <div style="text-align: center; cursor: pointer;">
                    <i class="el-icon-money" style="font-size: 36px; color: #67C23A;"></i>
                    <h4>Bank Transfer</h4>
                    <p style="font-size: 12px; color: #909399;margin-top: 10px;">Send the invoice to your school's finance department and let your school pay via bank transfer. <br>It will take 3-5 business days to process.</p>
                  </div>
                  <div style="margin-top: 20px; text-align: center;" class="payment-buttons">
                    <el-button 
                      type="primary" 
                      class="action-button"
                      
                      @click="viewBankAccountDetails">
                      View EAE's Bank Account Details
                    </el-button>
                    <el-upload
                      action="/"
                      :show-file-list="false"
                      :before-upload="beforeProofUpload">
                      <el-button
                        type="success"
                        class="action-button"
                        :disabled="!paymentTermsAccepted"
                        :loading="uploadingProof">
                        {{ currentPayment && currentPayment.institution_payment_proof_url ? 'Replace file' : 'Upload proof of payment' }}
                      </el-button>
                    </el-upload>
                    <el-button 
                      type="primary" 
                      class="action-button"
                      
                      @click="downloadInvoice">
                      Download Invoice
                    </el-button>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            
            
          </div>
        </div>
        
        <div v-else-if="!loadingPaymentDetails" style="text-align: center; padding: 30px 0;">
          <i class="el-icon-warning-outline" style="font-size: 48px; color: #E6A23C;"></i>
          <p style="margin-top: 15px; color: #606266;">Payment details not available</p>
        </div>
      </div>
    </el-dialog>
    <el-dialog 
      :visible.sync="showBankDetailsDialog" 
      title="Bank Account Information" 
      width="70%"
      :append-to-body="true" style="word-break: keep-all; white-space: normal;">
      <div style="padding: 0 20px;">
        <h3 style="text-align: center; color: #409EFF; margin-bottom: 20px;">
          Bank Transfer Information
        </h3>
        
        <el-divider content-position="left">
          <span style="font-weight: bold; color: #606266;">SWIFT ACCOUNT DETAILS (for international transfers outside Singapore)</span>
        </el-divider>
        
        <el-descriptions :column="1" border>
          <el-descriptions-item label="Account Holder Name">
            EXTRACURRICULAR EXCELLENCE INT PTE. LTD.
          </el-descriptions-item>
          <el-descriptions-item label="ACCOUNT NUMBER/IBAN">
            072-152241-1
          </el-descriptions-item>
          <el-descriptions-item label="SWIFT/BIC Code">
            DBSSSGSG
          </el-descriptions-item>
          <el-descriptions-item label="Bank Name">
            DBS Bank Ltd Singapore
          </el-descriptions-item>
          <el-descriptions-item label="Bank Country">
            Singapore (SG)
          </el-descriptions-item>
          <el-descriptions-item label="Bank Address">
            12 Marina Boulevard, Marina Bay Financial Centre Tower 3, Singapore 018982
          </el-descriptions-item>
        </el-descriptions>
        
        <el-divider content-position="left" style="margin-top: 30px;">
          <span style="font-weight: bold; color: #606266;">LOCAL ACCOUNT DETAILS (only for local transfers within Singapore)</span>
        </el-divider>
        
        <el-descriptions :column="1" border>
          <el-descriptions-item label="Account Holder Name">
            EXTRACURRICULAR EXCELLENCE INT PTE. LTD.
          </el-descriptions-item>
          <el-descriptions-item label="ACCOUNT NUMBER/IBAN">
            072-152241-1
          </el-descriptions-item>
          <el-descriptions-item label="SWIFT/BIC CODE">
            -
          </el-descriptions-item>
          <el-descriptions-item label="Bank Name">
            DBS Bank Ltd Singapore
          </el-descriptions-item>
          <el-descriptions-item label="Bank Country">
            Singapore (SG)
          </el-descriptions-item>
          <el-descriptions-item label="Bank Address">
            12 Marina Boulevard, Marina Bay Financial Centre Tower 3, Singapore 018982
          </el-descriptions-item>
        </el-descriptions>
        
        <div style="margin-top: 30px; background-color: #f0f9eb; padding: 15px; border-radius: 4px; border-left: 4px solid #67C23A;">
          <h4 style="color: #67C23A; margin-bottom: 10px;">Important Notes:</h4>
          <ul style="color: #606266; padding-left: 20px;">
            <li>Please include your <strong>Invoice Number</strong> in the transfer reference.</li>
            <li>After completing the transfer, please also upload the proof of payment for confirmation.</li>
            <li>The institution price is net to EAE. Please choose OUR / all bank charges paid by sender when available.</li>
            <li>GST is 0.00 under the current exemption / not applicable policy.</li>
            <li>Bank transfers may take 3-5 business days to process.</li>
          </ul>
        </div>
        
        
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isShowCopyDialog" title="Student Registration Link" width="50%">
      <div class="content">
        <div style="padding: 0 10px">Please copy and share the link with your student for registration.</div>
        <div class="linkbox" style="display: flex;width: 100%;margin-top: 16px;">
          <span class="link">{{ linkStr }}</span>
          <el-button type="primary" size="medium" @click="copyLink">Copy</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getContactsByAccount,
  updateAccountApplicationContacts,
  getSchoolRegistrations,
  postRequest,
  checkApplication,
  getQiniuToken,
  updateInstitutionPaymentProof
} from '../../api/eae'
import {
  getAccountId,
  setTargetType,
  getUserType,
  getUserId
} from '../../utils/store'
import {
  getPrototypeInstitutionTermsHtml
} from '../../utils/institutionPayment'
import {
  formatReviewDate,
  getReviewCycleDisplayName,
  getRegistrationRowBu,
  getAmParticipationNote,
  getNimReviewCyclesForNotes
} from '../../utils/registrationNotes'
import * as qiniu from 'qiniu-js'

export default ({
  name: 'index',
  data() {
    return {
      teacherOpt: [],
      dataList: [],
      isShowDialog: false,
      rowData: {},
      selectContactIds: [],
      showPaymentDetailsDialog: false,
      currentPayment: null,
      loadingPaymentDetails: false,
      selectedPaymentMethod: '',
      showBankDetailsDialog: false,
      isShowCopyDialog: false,
      linkStr: '',
      uploadingProof: false,
      paymentTermsAccepted: false,
    }
  },
  mounted() {
    this.fetchData()
    setTargetType('school')
    this.getSubjectList()
  },
  methods: {
    getReviewCycleDisplayName,
    formatReviewDate,
    getAmParticipationNote,

    getRowBu(row) {
      return getRegistrationRowBu(row)
    },

    getNimReviewCycles(row) {
      return getNimReviewCyclesForNotes(row)
    },

    formatContactName(contact) {
      if (contact.contact_enName) {
        return contact.contact_enName
      }
      return contact.contact_lastName + ' ' + contact.contact_givenName
    },

    getSubjectList() {
      this.teacherOpt = []
      getContactsByAccount(getAccountId()).then((res) => {
        if (res.data.length > 0) {
          this.teacherOpt = res.data
        }
      })
    },
    fetchData() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getSchoolRegistrations(getAccountId(), 'school').then((res) => {
        const rows = Array.isArray(res.data) ? res.data : []
        this.dataList = rows.filter((row) => {
          const bu = row.project && row.project.project_BU
            ? String(row.project.project_BU).toUpperCase()
            : ''
          return bu !== 'DSA'
        })
        loading.close()
      })
    },
    tableCellstyle() {
      return 'background:  #FAE3E4;border:1px solid white;text-align:center; font-family: Ubuntu-Bold;'
    },

    convertTimeToEng(time) {
      var date = new Date(time * 1000);
      let year = date.getFullYear();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      return this.formatMonthToEng(month) + " " + day + ", " + year;
    },

    formatMonthToEng(month) {
      switch (month) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },
    showDialog(data) {
      this.selectContactIds = []
      this.rowData = data
      this.isShowDialog = true
    },
    closeDialog() {
    },
    saveInfo() {
      if (this.selectContactIds.length <= 0) {
        this.$message.warning('Please select advisors')
        return
      }
      let oldContacts = [];
      // if (this.rowData.application_contacts && this.rowData.application_contacts.length > 0) {
      //   oldContacts = this.rowData.application_contacts
      // }
      let newContacts = this.selectContactIds.concat(oldContacts)
      //合并之后，
      const uniqueContacts = [...new Set(newContacts)]
      updateAccountApplicationContacts(this.rowData._id.$id, uniqueContacts).then((res) => {
        this.$message.success('Assign Advisor Successful')
        this.isShowDialog = false
        this.fetchData()
      })
    },
    viewPaymentDetails(row) {
      this.showPaymentDetailsDialog = true;
      this.loadingPaymentDetails = true;
      this.currentPayment = null;
      this.selectedPaymentMethod = '';
      this.paymentTermsAccepted = false;
      
      checkApplication(row._id.$id).then(res => {
        if (res.data && res.data.code === 0) {
          this.currentPayment = this.normalizePaymentData(res.data.data || row, row);
        } else {
          // If API fails, use row data as fallback
          this.currentPayment = this.normalizePaymentData(row, row);
          this.$message.warning('Could not fetch detailed payment information');
        }
        this.loadingPaymentDetails = false;
      }).catch(err => {
        console.error('Error fetching payment details:', err);
        this.currentPayment = this.normalizePaymentData(row, row);
        this.loadingPaymentDetails = false;
        this.$message.error('Failed to load payment details');
      });
    },
    normalizePaymentData(payment, row) {
      const current = payment || {}
      if (!current.project && row && row.project) {
        current.project = row.project
      }
      return current
    },
    calcReductionAmount(payment) {
      const standardFee = Number(payment.standard_fee || payment.institution_price || payment.project?.project_price || 0)
      const totalPrice = Number(payment.total_price || payment.institution_price || 0)
      return Math.max(0, standardFee - totalPrice)
    },
    getTotalOrderAmount(payment) {
      if (!payment) return 0
      return Number(payment.total_price || payment.institution_price || 0) + Number(payment.service_fee || 0)
    },
    getInstitutionTermsPolicy(payment) {
      const policy = payment && (payment.institution_terms_policy || (payment.project && payment.project.institution_terms_policy))
        ? String(payment.institution_terms_policy || payment.project.institution_terms_policy)
        : ''
      if (policy.trim() !== '' && (policy.indexOf('Draft') !== -1 || policy.indexOf('licence') !== -1 || policy.indexOf('license') !== -1)) {
        return policy.replaceAll('\r\n\r\n', '<br><br>')
      }
      return getPrototypeInstitutionTermsHtml()
    },
    formatCurrency(amount) {
      if (amount === undefined || amount === null || amount === '') return 'N/A';
      
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount);
    },
    formatDate(timestamp) {
      if (!timestamp) return 'N/A';
      
      const date = new Date(timestamp);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    formatUnixTime(timestamp) {
      if (!timestamp) return 'N/A'
      return this.formatDate(Number(timestamp) * 1000)
    },
    getProofStatusType(status) {
      if (status === 'Verified') return 'success'
      if (status === 'Partially paid') return 'warning'
      if (status === 'Needs resubmission') return 'danger'
      return 'info'
    },
    getPaymentStatusType(status) {
      if (!status) return 'info';
      
      switch (status) {
        case '已缴费':
        case '无需缴费':
        case 'Paid':
          return 'success';
        case '待缴费':
        case 'Pending':
          return 'warning';
        case '部分支付':
        case 'Partially paid':
          return 'warning';
        case '已过期':
        case 'Expired':
          return 'danger';
        default:
          return 'info';
      }
    },
    getSchoolProgramStatusType(status) {
      switch (status) {
        case '待缴费':
          return 'warning'
        case '部分支付':
          return 'warning'
        case '已缴费':
        case '无需缴费':
        case '已报名':
          return 'success'
        default:
          return 'info'
      }
    },
    getSchoolProgramStatusLabel(status, project) {
      switch (status) {
        case '待缴费':
          return 'Pending Payment'
        case '部分支付':
          return 'Partially Paid'
        case '已缴费':
          return 'Paid'
        case '无需缴费':
          return 'No Payment Required'
        case '已报名':
          return project && project.project_status === 'active' ? 'Registered' : 'Completed'
        default:
          return status || 'Unknown'
      }
    },
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method;
    },
    downloadReceipt(url) {
      if (!url) {
        this.$message.warning('Receipt not available');
        return;
      }
      
      window.open(url, '_blank');
    },
    proceedToPayment() {
      if (!this.selectedPaymentMethod) {
        this.$message.warning('Please select a payment method');
        return;
      }
      if (!this.paymentTermsAccepted) {
        this.$message.warning('Please accept the payment terms and conditions before continuing.');
        return;
      }
      
      if (this.selectedPaymentMethod === 'creditCard') {
        // this.$message.info('Redirecting to credit card payment gateway...');
        // Implement redirect to payment gateway
        this.processPayment('creditCard');
      } else if (this.selectedPaymentMethod === 'bankTransfer') {
        this.$message.info('Showing bank transfer instructions...');
        // Show bank transfer instructions
        this.processPayment('bankTransfer');
      }
    },
    processPayment(method) {
      if (!this.currentPayment || !this.currentPayment._id) {
        this.$message.error('Invalid payment data');
        return;
      }

      if (method == 'creditCard'){
        this.$router.push({
            path: '/home/program-order',
            query: {
                application_id: this.currentPayment._id.$id
            }
        })

        return;
      }
      
      // Call API to process payment
      postRequest({
        function: 'initiatePayment',
        application_id: this.currentPayment._id.$id,
        payment_method: method
      }).then(res => {
        if (res.data && res.data.code === 0) {
          if (method === 'creditCard' && res.data.data.redirect_url) {
            window.open(res.data.data.redirect_url, '_blank');
          } else if (method === 'bankTransfer' && res.data.data.bank_details) {
            // Display bank details in a new dialog or component
            this.$alert(this.formatBankDetails(res.data.data.bank_details), 'Bank Transfer Details', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: 'OK'
            });
          }
          this.showPaymentDetailsDialog = false;
        } else {
          this.$message.error('Failed to initiate payment: ' + (res.data?.msg || 'Unknown error'));
        }
      }).catch(err => {
        console.error('Error initiating payment:', err);
        this.$message.error('Failed to initiate payment. Please try again later.');
      });
    },
    formatBankDetails(details) {
      if (!details) return 'Bank details not available';
      
      return `
        <div style="text-align: left">
          <p><strong>Bank Name:</strong> ${details.bank_name}</p>
          <p><strong>Account Name:</strong> ${details.account_name}</p>
          <p><strong>Account Number:</strong> ${details.account_number}</p>
          <p><strong>Routing Number:</strong> ${details.routing_number}</p>
          <p><strong>Swift Code:</strong> ${details.swift_code}</p>
          <p><strong>Reference:</strong> ${details.reference}</p>
          <p><strong>Amount:</strong> ${this.formatCurrency(details.amount)}</p>
          <hr>
          <p><strong>Please include your Reference number in the transfer notes.</strong></p>
          <p>After completing the transfer, please upload proof of payment to confirm your registration.</p>
        </div>
      `;
    },
    viewBankAccountDetails() {
      this.showBankDetailsDialog = true;
    },
    async beforeProofUpload(file) {
      if (!this.currentPayment || !this.currentPayment._id) {
        this.$message.error('Payment application not available')
        return false
      }
      if (!this.paymentTermsAccepted) {
        this.$message.warning('Please accept the payment terms and conditions before uploading proof of payment.')
        return false
      }
      const isAllowedType = ['application/pdf', 'image/jpeg', 'image/png'].includes(file.type)
      if (!isAllowedType) {
        this.$message.warning('Please upload a PDF, JPG, or PNG file.')
        return false
      }
      if (file.size / 1024 / 1024 > 10) {
        this.$message.warning('Proof file must be 10MB or smaller.')
        return false
      }
      this.uploadingProof = true
      try {
        const result = await getQiniuToken()
        if (!result.data || result.data.code !== 0) {
          this.$message.error('Failed to prepare upload token')
          this.uploadingProof = false
          return false
        }
        const token = result.data.data
        const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_')
        const key = 'institution-payment-proof/' + new Date().getTime() + '-' + safeName
        const observable = qiniu.upload(file, key, token)
        observable.subscribe({
          error: () => {
            this.uploadingProof = false
            this.$message.error('Upload failed. Please try again.')
          },
          complete: (res) => {
            const proofUrl = 'https://ap.learningfirst.io/' + res.key
            updateInstitutionPaymentProof({
              application_id: this.currentPayment._id.$id,
              proof_url: proofUrl,
              proof_file_name: file.name,
              uploaded_by: getUserId() || ''
            }).then((saveRes) => {
              this.uploadingProof = false
              if (saveRes.data && saveRes.data.code === 0) {
                this.$message.success('Proof uploaded. Finance will verify the payment.')
                this.currentPayment = this.normalizePaymentData(saveRes.data.data, this.currentPayment)
                this.fetchData()
              } else {
                this.$message.error(saveRes.data?.msg || 'Failed to save proof information')
              }
            }).catch(() => {
              this.uploadingProof = false
              this.$message.error('Failed to save proof information')
            })
          }
        })
      } catch (e) {
        this.uploadingProof = false
        this.$message.error('Upload failed. Please try again.')
      }
      return false
    },
    showRegistrationLink(data) {
      if (!data || !data.project) {
        this.$message.warning('Registration link is not available')
        return
      }
      let url = 'https://my.eae.international/#/form/registration?account_id=' + data.account_id
        + '&project_code=' + data.project.project_code
      if (data.participation_arrangement === 'School day') {
        url += '&institution_app_id=' + data._id.$id
      } else {
        url += '&participation_arrangement=Standard%20registration'
      }
      if (getUserType() === 'advisor') {
        let contactId = getUserId()
        url += '&contact_id=' + contactId + '&advisor_id=' + contactId
      }
      this.linkStr = url
      this.isShowCopyDialog = true
    },
    isInstitutionPaymentPending(row) {
      return row && row.participation_arrangement === 'School day'
        && (row.application_status === '待缴费' || row.application_status === '部分支付')
    },
    isStandardRegistration(row) {
      return row && (row.participation_arrangement === 'Standard registration' || (!row.participation_arrangement && row.application_status === '已报名'))
    },
    hasRegistrationResourceActions(row) {
      return row && !this.isInstitutionPaymentPending(row)
        && (row.application_status === '已缴费' || this.isStandardRegistration(row))
    },
    handleRegistrationResourceAction(command, row) {
      if (command === 'invoice') {
        this.downloadInvoice(row)
      } else if (command === 'receipt') {
        this.viewReceipt(row)
      } else if (command === 'brandAuth') {
        this.$router.push({
          path: '/home/brandAuthorization',
          query: { application_id: row._id.$id }
        })
      }
    },
    copyLink() {
      navigator.clipboard.writeText(this.linkStr).then(() => {
        this.isShowCopyDialog = false
        this.$message.success('Copy Success')
      }).catch(() => {
        this.$message.error('Copy failed')
      })
    },
    downloadBankDetails() {
      this.$message.info('Downloading bank details as PDF...');
      
      setTimeout(() => {
        this.$message.success('Bank details downloaded successfully');
      }, 1000);
    },
    goToProjectDetail(project) {
      this.$router.push({
        path: '/home/programsDetail',
        query: {
          project_id: project._id.$id,
          from: 'school'
        }
      });
    },
    downloadInvoice(row){
      const target = row || this.currentPayment
      if (!target || !target._id) {
        this.$message.warning('Invoice not available')
        return
      }
      this.$router.push({
          path:'/home/schoolInvoice',
          query:{
              id:target._id.$id
          }
      })
    },
    viewReceipt(row) {
      const target = row || this.currentPayment
      if (!target || !target._id) {
        this.$message.warning('Receipt not available')
        return
      }
      this.$router.push({
        path: '/home/schoolInvoice',
        query: {
          id: target._id.$id,
          document: 'receipt'
        }
      })
    },
  }
})
</script>
<style scoped lang="scss">
/deep/ .el-table .custom-row-bg {
  background: #FAE3E4;
}

/deep/ .el-table tbody .cell {
  font-family: Ubuntu-Light;
}

/deep/ .el-table .custom-head-cell {
  background: var(--c-primary);
  color: white;
  text-align: center;
  border: 1px solid white;
  box-sizing: border-box;
  font-family: Ubuntu-Bold;
}

.notes-am-text {
  display: inline-block;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  line-height: 1.35;
  font-size: 11px;
}

.notes-nim-cycles {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
  font-size: 11px;
  line-height: 1.35;
}

.notes-nim-cycle {
  min-width: 0;
}

.notes-nim-cycle-name {
  font-weight: 600;
}

.notes-nim-cycle-date {
  color: #666;
}

.payment-method-selected {
  border: 2px solid #409EFF;
  transform: translateY(-3px);
  transition: all 0.3s;
}

.el-card {
  transition: all 0.3s;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
  }
}

.payment-buttons {
  margin-top: 30px;
}

.action-button {
  margin-top: 10px;
  margin-right: 10px;
  min-width: 180px;
}

.order-total-line {
  align-items: center;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  padding: 12px 16px;
}

.institution-terms-block {
  background: #fcfcfa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 14px 16px;
}

.terms-title {
  color: #303133;
  font-weight: 600;
  margin-bottom: 10px;
}

.terms-content {
  max-height: 220px;
  overflow-y: auto;
  color: #606266;
  font-size: 13px;
  line-height: 20px;
}

.terms-draft-tag {
  display: inline-block;
  background: #faeeda;
  border: 1px solid #fac775;
  border-radius: 4px;
  color: #854f0b;
  font-size: 12px;
  padding: 2px 8px;
}

.el-descriptions {
  margin-bottom: 10px;
  
  /deep/ .el-descriptions-item__label {
    font-weight: bold;
    background-color: #f5f7fa;
  }
}
</style>
